import * as Yup from "yup";

const schema = Yup.object().shape({
  constructionSiteDisciplinesFk: Yup.array(Yup.number()).required('discipline'),
  pointsFk: Yup.array(Yup.string()).required('point'),
});

export default schema;